export default __webpack_public_path__ + "static/media/logo.5fc434a4.png";